/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-09-14 16:33:26
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-10-18 16:55:58
 */
import type { Reducer, Effect } from 'umi'
import { getLogProjectCardList } from '@/services/project/log'

interface StateType {
  viewType: number
  cardList: any[]
}

export interface LogModelType {
  namespace: string
  state: StateType
  effects: {
    fetchCardList: Effect
    fetchCreateProject: Effect
  }
  reducers: {
    saveCardList: Reducer<StateType>
    saveViewType: Reducer<StateType>
  }
}

const IndexModel: LogModelType = {
  namespace: 'workbenchLog',

  state: {
    viewType: 1, //　视图：1卡片视图 2列表视图
    cardList: [] //  卡片列表
  },

  effects: {
    // 项目列表
    *fetchCardList({ payload }, { select, call, put }) {
      const res = yield call(getLogProjectCardList, payload)
      yield put({
        type: 'saveCardList',
        payload: {
          data: res.data?.card || [],
          page: payload.page || 1
        }
      })
    }
  },

  reducers: {
    saveCardList(state, { payload }): any {
      const { data, page } = payload
      let result = []

      if (page == 1) {
        result = data
      } else {
        result = state?.cardList || []
        result.forEach((item: any, index: number) => {
          item.list = item.list.concat(data[index].list)
        })
      }

      return {
        ...state,
        cardList: result
      }
    },
    saveViewType(state, { payload }): any {
      return {
        ...state,
        viewType: payload
      }
    }
  }
}

export default IndexModel
